export default __webpack_public_path__ + "2019 Vacuum-enhanced optical nonlinearities with disordered molecular photoswitches.pdf";